"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
require("./TextImage.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = _typography.default.Title,
  Text = _typography.default.Text;
var TextImage = function TextImage(_ref) {
  var orientation = _ref.orientation,
    title = _ref.title,
    subtitle = _ref.subtitle,
    imgSrc = _ref.imgSrc,
    link = _ref.link,
    linkText = _ref.linkText,
    btnlink = _ref.btnlink,
    btnText = _ref.btnText,
    text = _ref.text;
  var textColumns = imgSrc ? 16 : 24;
  return orientation === 'vertical' ? /*#__PURE__*/_react.default.createElement("div", {
    className: "text-image vertical"
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-around",
    align: "middle"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    className: "container-inner"
  }, /*#__PURE__*/_react.default.createElement(Title, {
    level: 1
  }, title), /*#__PURE__*/_react.default.createElement(Title, {
    level: 3
  }, subtitle), /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, linkText), /*#__PURE__*/_react.default.createElement(Text, {
    level: 3
  }, text), btnlink && /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    size: "large",
    onClick: btnlink,
    className: "push-down full-width-btn"
  }, btnText)), imgSrc ? /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    className: "image-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imgSrc,
    alt: ""
  })) : '')) : /*#__PURE__*/_react.default.createElement("div", {
    className: "text-image"
  }, /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "space-around",
    align: "middle"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: textColumns,
    className: "container-inner"
  }, /*#__PURE__*/_react.default.createElement(Title, {
    level: 1
  }, title), /*#__PURE__*/_react.default.createElement(Title, {
    level: 3
  }, subtitle), /*#__PURE__*/_react.default.createElement("a", {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, linkText), /*#__PURE__*/_react.default.createElement(Text, {
    level: 3
  }, text), btnlink && /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    size: "large",
    onClick: btnlink,
    className: "push-down"
  }, btnText)), imgSrc ? /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 8,
    className: "image-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imgSrc,
    alt: ""
  })) : ''));
};
var _default = TextImage;
exports.default = _default;